import {
  LOGIN_EXITOSO,
  REGISTRO_EXITOSO,
  LOGIN_ERROR,
  REGISTRO_ERROR,
  CERRAR_SESION,
  OBTENER_USUARIO,
} from "../../types";

export default (state, action) => {
  switch (action.type) {
    case LOGIN_EXITOSO:
    case REGISTRO_EXITOSO:
      localStorage.setItem("token", action.payload.token);
      return {
        ...state,
        token: action.payload.token,
      };
    case OBTENER_USUARIO:
      return {
        autenticado: true,
        cargando: false,
        usuario: action.payload,
      };
    case CERRAR_SESION:
      localStorage.removeItem("token");

      return action.payload;
    default:
      return state;
  }
};
